<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('nomor')">Nomor <i
                :class="currentSort === 'nomor' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('deskripsi')">Deskripsi <i
                :class="currentSort === 'deskripsi' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('aliasing')">Aliasing <i
                :class="currentSort === 'aliasing' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('last_modified_date')">Last Modified Date <i
                :class="currentSort === 'last_modified_date' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('last_modified_by')">Last Modified By <i
                :class="currentSort === 'last_modified_by' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('status')">Status <i
                :class="currentSort === 'status' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
            <th @click="sort('catatan')">Catatan <i
                :class="currentSort === 'catatan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)"><span class="fa fa-edit pointer ml20"></span></td>
            <td>{{ index + 1 }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ list.folder }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ list.update_by ? list.update_by : 'System' }}</td>
            <td :style="{ color: list.is_active === 'Active' ? 'green' : 'red' }">{{ list.is_active ? 'Aktif' : "Tidak" }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <EditPerizinan v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
  </div>
</template>
    
<script>
export default {
  components: {
    EditPerizinan: () => import('@/components/masterdata/matrix/dokumen/edit/perizinan.vue')
  },

  props: {
    'isEdit': Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        folder: data.folder,
        updatedAt: data.updatedAt,
        is_active: data.is_active,
        note: data.note,
      }
      this.showModalEdit = true;
    },
    closeModal() {
      this.showModalEdit = false;
    },
  },

  computed: {
    legalDoc() {
      const legal = this.$store.state.mdMatrixLegalStore.legal_doc;
      let akta = legal.filter((item) => {
        return item.type === 3;
      });

      return akta
    },
    sortedData() {
      return this.legalDoc.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    }
  },

}
</script>